import { Injector } from "@angular/core";
import { Functions, httpsCallable } from '@angular/fire/functions';
import { getFunctions } from "firebase/functions";
import type { RequestBodyService } from "./services/request-body.service";

/** Keep in sync with AuthService.FIREBASE_REGION — avoid importing AuthService here (circular DI). */
const FIREBASE_REGION = "europe-west3";

export class BaseService {
  public functions: Functions;
  public requestBodyService: RequestBodyService;
  public synchronizerFunction: any;
  public callableFunction: any;
  public validatePostAsyncEvents;
  public postAsyncEvents;
  public gamipressFunction: any;
  public wpUserFunction: any;
  public twilioValidationFunction: any;
  public apiValidateAsync: any;

  constructor(injector: Injector) {
    const functions = getFunctions();
    functions.region = FIREBASE_REGION;

    // Lazy require avoids BaseService ↔ AuthService ↔ FirestoreDataService circular init.
    const { RequestBodyService: RequestBodyServiceCtor } = require("./services/request-body.service");
    this.requestBodyService = injector.get(RequestBodyServiceCtor);
    this.synchronizerFunction = httpsCallable(this.functions, 'synchronise');
    this.callableFunction = httpsCallable(functions, "apiv2");
    this.postAsyncEvents = httpsCallable(functions, "postasynceventsv2");
    this.validatePostAsyncEvents = httpsCallable(functions, "validatepostasynceventsv2");
    this.gamipressFunction = httpsCallable(this.functions, "awardPoints");
    this.wpUserFunction = httpsCallable(functions, "addwpuserv2");
    this.twilioValidationFunction = httpsCallable(functions, "validatemsnv2");
    this.apiValidateAsync = httpsCallable(functions, "apivalidateasyncv2");
  }
}
